import { BaseAction } from '../IBaseActionResult';
import { app_baiviet_view } from './../../../models/response/app-phuhuynh/app_baiviet_view';
import { eBaiVietViewActionTypeIds, IBaiVietViewLoadError, IBaiVietViewLoadStart, IBaiVietViewLoadSuccess } from './../../action-types/bai-viet/IBaiVietViewActionTypes';
export const baiVietViewActions = {
    loadStart: (id: number): IBaiVietViewLoadStart => BaseAction(id, eBaiVietViewActionTypeIds.LOAD_START),
    loadSuccess: (data: app_baiviet_view[]): IBaiVietViewLoadSuccess => BaseAction(data, eBaiVietViewActionTypeIds.LOAD_SUCCESS),
    loadErr: (message: string): IBaiVietViewLoadError => BaseAction(message, eBaiVietViewActionTypeIds.LOAD_ERROR),
}